/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { WorkbookId } from "../../commons/types/WorkbookId";
import { SpaceId } from "../../commons/types/SpaceId";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { Sheet } from "../../sheets/types/Sheet";
import { Action } from "../../commons/types/Action";
import { WorkbookConfigSettings } from "./WorkbookConfigSettings";
import { WorkbookTreatments } from "./WorkbookTreatments";
import { StorageStrategy } from "./StorageStrategy";
export const Workbook = core.serialization.object({
    id: WorkbookId,
    name: core.serialization.string().optional(),
    spaceId: SpaceId,
    environmentId: EnvironmentId,
    sheets: core.serialization.list(Sheet).optional(),
    labels: core.serialization.list(core.serialization.string()).optional(),
    actions: core.serialization.list(Action).optional(),
    settings: WorkbookConfigSettings.optional(),
    metadata: core.serialization.any().optional(),
    treatments: core.serialization.list(WorkbookTreatments).optional(),
    namespace: core.serialization.string().optional(),
    updatedAt: core.serialization.date(),
    createdAt: core.serialization.date(),
    expiredAt: core.serialization.date().optional(),
    storageType: core.serialization.string().optional(),
    storageStrategy: StorageStrategy.optional(),
    createdFrom: WorkbookId.optional(),
    lastPropagatedAt: core.serialization.date().optional(),
    folder: core.serialization.string().optional(),
});
